import React from 'react';
import * as Ons from 'react-onsenui';
import Modal from './Modal';
import Player from './ListItems/Player';
import PlayerListSettings from '../containers/Pages/PlayerListSettings';
import { getPlayerPositions, getTeamOfficialPositions, supports } from '../util/context';
import { translate as _ } from '../util/i18n';

class PlayerList extends React.Component {

    #playerPositions;
    #teamOfficialPositions;

    constructor( props ) {

        super( props );

        this.state = {
            playerListSettingsOpen: false,
            searchDisplay:          '',
            searchQuery:            ''
        };

        this.filterPlayer                  = this.filterPlayer.bind( this );
        this.handleClosePlayerListSettings = this.handleClosePlayerListSettings.bind( this );
        this.handleOpenPlayerListSettings  = this.handleOpenPlayerListSettings.bind( this );
        this.handleSearchChange            = this.handleSearchChange.bind( this );
        this.sortPlayers                   = this.sortPlayers.bind( this );

        this.#playerPositions       = getPlayerPositions(       props.context ) || [];
        this.#teamOfficialPositions = getTeamOfficialPositions( props.context ) || [];

    }

    filterPlayer( player ) {

        if ( ! this.state.searchQuery ) {

            return true;

        }

        if ( player.lastname && player.lastname.toLowerCase().indexOf( this.state.searchQuery ) !== -1 ) {

            return true;

        }

        if ( player.firstname && player.firstname.toLowerCase().indexOf( this.state.searchQuery ) !== -1 ) {

            return true;

        }

        if ( player.middlename && player.middlename.toLowerCase().indexOf( this.state.searchQuery ) !== -1 ) {

            return true;

        }

        return false;

    }

    getEmptyPlayersList() {

        if ( this.props.playerListSettings.groupBy === 'line' ) {

            return ( supports( this.props.context, 'lineup' ) && this.props.type !== 'TeamOfficials' ) ? {} : [];

        }

        return ( this.props.playerListSettings.groupBy ? {} : [] );

    }

    handleClosePlayerListSettings() {

        this.setState( { playerListSettingsOpen: false } );

    }

    handleOpenPlayerListSettings() {

        this.setState( { playerListSettingsOpen: true } );

    }

    handleSearchChange( e ) {

        this.setState( {
            searchDisplay: e.target.value,
            searchQuery:   e.target.value.toLowerCase()
        } );

    }

    renderPlayerList( players, header ) {

        return (

            <Ons.List
                className={'player-list ' + ( this.props.type === 'TeamOfficials' ? 'compact' : ( this.props.playerListSettings.view || '' ) )}
                dataSource={players}
                key={header}
                renderHeader={() => header ? <Ons.ListHeader>{header}</Ons.ListHeader> : null}
                renderRow={
                    ( player, idx ) => {

                        return (

                            this.filterPlayer( player ) &&

                            <Player
                                activatable={this.props.playersActivatable( player )}
                                disabled={this.props.playersDisabled}
                                format={this.props.playerFormat}
                                isActive={this.props.playerIsActive( player )}
                                key={player.id + '-' + idx}
                                modifier={idx === players.length - 1 ? 'longdivider' : null}
                                onActivate={this.props.onPlayerActivate( player )}
                                onClick={this.props.onPlayerClick}
                                onJerseyNrClick={this.props.onPlayerJerseyNrClick}
                                player={player}
                                textActivate={this.props.textActivatePlayer}
                                textIsActive={this.props.textPlayerIsActive}
                                type={this.props.type}
                            />

                        );

                    }
                }
            />

        );

    }

    sortPlayers( a, b ) {

        return this.sortPlayersByKey( a, b, this.props.playerListSettings.sortBy || 'lastname' );

    }

    sortPlayersByKey( a, b, key ) {

        if ( this.props.type === 'TeamOfficials' ) {

            if ( key === 'position' ) { key = 'job';      }
            if ( key === 'line'     ) { key = 'lastname'; }

        }

        return ( a[ key ] < b[ key ] ? -1 : a[ key ] > b[ key ] ? 1 : 0 );

    }

    render() {

        const players        = this.getEmptyPlayersList();
        const positions      = [ ...( this.props.type === 'Players' ? this.#playerPositions : this.#teamOfficialPositions ), [ 'undefined', _( this.props.type === 'Players' ? 'Keine Position' : 'Keine Funktion' ) ] ];
        const groupByLine    = this.props.playerListSettings.groupBy === 'line' && supports( this.props.context, 'lineup' ) && this.props.type !== 'TeamOfficials';
          let playersByLines = null;

        if ( this.props.players && this.props.players.length ) {

            this.props.players.sort( this.sortPlayers );

            this.props.players.forEach( player => {

                if ( this.props.playerListSettings.groupBy === 'position' ) {

                    const position = ( this.props.type === 'TeamOfficials' ? player.job : player.position ) || 'undefined';

                    if ( ! ( position in players ) ) {

                        players[ position ] = [];

                    }

                    players[ position ].push( player );

                } else if ( groupByLine ) {

                    const line = player.line ? _( 'Linie' ) + ' ' + player.line : _( 'Keine Linie' );

                    if ( ! ( line in players ) ) {

                        players[ line ] = [];

                    }

                    players[ line ].push( player );

                } else {

                    players.push( player );

                }

            } );

        }

        if ( groupByLine ) {

            playersByLines = Object.entries( players );

            playersByLines.sort( ( a, b ) => a[ 0 ] < b[ 0 ] ? -1 : a[ 0 ] > b[ 0 ] ? 1 : 0 );

        }

        return (

            <>

                <div className="search-input-container">
                    <Ons.SearchInput
                        onChange={this.handleSearchChange}
                        placeholder={_( this.props.type === 'TeamOfficials' ? 'Team-Offizielle suchen' : 'Spieler suchen' )}
                        value={this.state.searchDisplay}
                    />
                    <Ons.Button onClick={this.handleOpenPlayerListSettings} modifier="quiet"><Ons.Icon icon="fa-sliders-h" /></Ons.Button>
                </div>

                {

                    this.props.playerListSettings.groupBy === 'position' ?

                        positions.map( position => {

                            if ( position[ 0 ] in players ) {

                                return this.renderPlayerList( players[ position[ 0 ] ], position[ 1 ] )

                            }

                            return null;

                        } )

                    : groupByLine ?

                        playersByLines.map( ( [ line, players ] ) => this.renderPlayerList( players, line ) )

                    :

                        this.renderPlayerList( players )

                }

                {this.state.playerListSettingsOpen && <Modal><PlayerListSettings onClose={this.handleClosePlayerListSettings}/></Modal>}

            </>

        );

    }

}

export default PlayerList;